import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const usePersonalInformationConfig = () => {
    const { t } = useTranslation();

    return useMemo(() => [
        {
            name: t("employee-number"),
            key: "employeeNumber",
        },
        {
            name: t("badge-id"),
            key: "badgeId",
        },
        {
            name: t("first-name"),
            key: "firstName",
        },
        {
            name: t("middle-name"),
            key: "middleName",
        },
        {
            name: t("last-name"),
            key: "lastName",
        },
        {
            name: t("gender"),
            key: "gender",
        },
        {
            name: t("ethnicity"),
            key: "race",
        },
        {
            name: t("email"),
            key: "email",
        },
        {
            name: t("phone-number"),
            key: "phone",
        },
    ], [t]);
}
